import React from 'react';
import PropTypes from 'prop-types';
import SummaryRow from './SummaryRow';
import FuturesIraDisclaimer from '../FuturesIraDisclaimer';

const SummarySection = (props) => {
  const {
    groupIndex,
    sectionIndex,
    title,
    summaryInfo,
    editLink,
    authToken,
    application,
    entity,
    errorMessage,
    editDisabled,
    iraHasFutures,
    iraHasOnlyFutures,
  } = props;

  const ent = entity === 'personal-info' ? 'address' : entity;
  const applicationStatus = application && application.status ? application.status : '';
  const isReturned = applicationStatus === 'returned' &&
    application.unlockedResources &&
    application.unlockedResources.indexOf(ent) > -1;
  const canEdit = (applicationStatus === 'in-progress' || isReturned)
    && ent !== 'registration' && ent !== 'securityCredentials' && !iraHasOnlyFutures;
  const editClasses = `btn btn-xs btn-info slimv_element ${(editDisabled ? 'disabled' : '')}`;
  let headerIndex = 0;
  const detailRows = summaryInfo.map((rowInfo, rowIndex) => {
    if (rowInfo.keyType === 'IDX') {
      headerIndex += 1;
    }
    return (
      <SummaryRow
        key={`summaryInfo_${title}_${rowIndex}_${rowInfo.key}`}
        rowInfo={rowInfo}
        index={rowIndex}
        headerIndex={headerIndex}
        parentTitle={title}
        authToken={authToken}
        canEdit={canEdit}
        editClasses={editClasses}
        editLink={rowInfo.editLinkOverride || editLink}
        {...props}
      />
    );
  });

  const accordionStyle = (errorMessage && errorMessage.length > 0) ? '' : 'collapsed';
  const accordionAriaExpanded = (errorMessage && errorMessage.length > 0) ? 'false' : 'true';
  const accordionDivStyle = (errorMessage && errorMessage.length > 0)
    ? 'panel-collapse collapse panel-summary in'
    : 'panel-collapse collapse panel-summary';

  return (
    <div className="panel">
      <div className="panel-heading" >
        <h3 className="panel-title">
          <a
            className={accordionStyle}
            role="button"
            data-toggle="collapse"
            data-parent={`#accordion-${groupIndex}`}
            href={`#collapse-${groupIndex}-${sectionIndex}`}
            aria-expanded={accordionAriaExpanded}
            aria-controls={`collapse-${groupIndex}-${sectionIndex}`}
          >
            <i className={`material-icons icon-success ${isReturned ? 'icon-danger' : ''}`}>
              {isReturned ? 'error' : 'check_circle'}
            </i>{title}
            <span className="pull-right clickable" />
          </a>
        </h3>
      </div>
      <div
        id={`collapse-${groupIndex}-${sectionIndex}`}
        className={accordionDivStyle}
        role="tabpanel"
        aria-labelledby="headingOne"
      >
        <div className="panel-body">
          <div className="row">
            {detailRows}
          </div>
          {(iraHasFutures || (errorMessage && errorMessage.length > 0)) &&
            <div className="row summary-row">
              {iraHasFutures && <FuturesIraDisclaimer page="summary" iraHasOnlyFutures={iraHasOnlyFutures} />}
              {errorMessage && errorMessage.length > 0 &&
                <div className="col-xs-12 summary-edit-wrapper">
                  <div className="col-xs-6 text-left">
                    <div className="error-text">
                      {errorMessage}
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  );
};

SummarySection.propTypes = {
  groupIndex: PropTypes.number.isRequired,
  sectionIndex: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  summaryInfo: PropTypes.arrayOf(PropTypes.shape({
    keyType: PropTypes.string.isRequired,
    valueType: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
    value: PropTypes.string,
  })),
  editLink: PropTypes.string.isRequired,
  authToken: PropTypes.string.isRequired,
  application: PropTypes.shape(),
  entity: PropTypes.string.isRequired,
  errorMessage: PropTypes.string,
  editDisabled: PropTypes.bool,
  iraHasFutures: PropTypes.bool,
  iraHasOnlyFutures: PropTypes.bool,
};

export default SummarySection;
